import React from 'react';

import type { PersonTrainerProfile } from '@rover/rsdk/src/apiClient/latest/model/personTrainerProfile';

import { SectionWithBottomSeparator } from '../PublicTrainerProfilePageLayout';

import MixedReviewsSection from './MixedReviewsSection/MixedReviewsSection';
import MoreInfoSection from './MoreInfoSection';
import WhatToExpectSection from './WhatToExpectSection';

interface ProfileContentReorderedSectionsProps {
  trainerInfo: PersonTrainerProfile;
}

const ProfileContentReorderedSections: React.FC<ProfileContentReorderedSectionsProps> = ({
  trainerInfo,
}) => {
  const { trainerProfile } = trainerInfo;
  const { details, education } = trainerProfile;

  return (
    <>
      <SectionWithBottomSeparator>
        <WhatToExpectSection trainerInfo={trainerInfo} isTrainerProfileReordering />
      </SectionWithBottomSeparator>

      <SectionWithBottomSeparator>
        <MoreInfoSection
          methodology={details.methodology}
          methodologyCustom={details.methodologyCustom || undefined}
          methodologyDetails={details.methodologyDetails || undefined}
          yearsOfTraining={details.yearsOfTraining}
          educationList={education}
          name={trainerInfo.shortName}
          defaultImage={trainerInfo.defaultImage}
        />
      </SectionWithBottomSeparator>

      <MixedReviewsSection trainerInfo={trainerInfo} hasBorderBottom={false} />
    </>
  );
};

export default ProfileContentReorderedSections;
